module.exports = __webpack_public_path__ + "img/pro_ten_3.b5e1442d.jpg";